import { SVGProps } from './SVGProps';

const ChevronRight = ({ fill = 'white', stroke = '#344054', width = '20', height = '20', ...rest }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="chevron-right">
        <path
          id="Icon"
          d="M7.5 15L12.5 10L7.5 5"
          stroke={stroke}
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ChevronRight;
